// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".flex[data-v-40ac36a6] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  gap: 10px;\n  -ms-flex-wrap: wrap;\n      flex-wrap: wrap;\n}\n.fr[data-v-40ac36a6] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: row;\n          flex-direction: row;\n}", ""]);
// Exports
module.exports = exports;
